<template>
    <div class="row d-flex align-items-end wrapper mt-5 pb-3">
        <div class="col-12 col-sm-3 d-none d-sm-block">
            <img :src="kotoriImg" class="img-fluid rounded"/>
        </div>
        <div class="col-12 col-sm-9 align-self-center">
            <div class="row justify-content-center">
                <div class="col-3">
                    <img :src="kotoriImg" class="kotori img-fluid rounded col-4 d-block d-sm-none d-md-none d-lg-none"/>
                </div>
                <h2 class="mt-2 mb-4 mb-sm-3 mt-sm-3 mb-lg-4 text-kotori col col-sm-12 text-center align-self-center">{{ $t('about') }}</h2>
            </div>
            <div class="row form-pc">
                <div class="col-12">
                    <p v-html="$t('runBy')"></p>
                    <p>{{ $t('aware') }}</p>
                    <ul>
                        <li>{{ $t('p1') }}</li>
                        <li>{{ $t('p2') }}</li>
                        <li>{{ $t('p3') }}</li>
                        <li>{{ $t('p4') }}</li>
                        <li>{{ $t('p5') }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

</template>

<i18n>
en:
  about: "About"
  runBy: "This site is run by <a href=\"https://www.cool2645.com\" >2645 Studio</a>, powered by <a href=\"https://yourls.org\" >YOURLS</a>."
  aware: "By using this site, you agree that you are aware and understand the following terms and conditions: "
  p1: "The site owner does not take any responsibility of any content linked to by user with the service of this site."
  p2: "Any shortened URL generated on this site may be remove unconditionally, without any notice or explanation."
  p3: "Your ability to use this service is a privilege, not a right. The site owner reserves the right to stop the service to anyone."
  p4: "The availability of this site is not guaranteed."
  p5: "You will not abuse this service, including but not limited to: mass requesting, unethical crawling, trying to get administrative access of the server and using the service for any illegal activities."
zh:
  about: "关于"
  runBy: "本站由 <a href=\"https://www.cool2645.com\" >2645 工作室</a> 创建并运行, 使用 <a href=\"https://yourls.org\" >YOURLS</a> 构建。"
  aware: "您使用本站服务，即表示您已知悉、理解并同意以下条款："
  p1: "本站短网址所指向的目标网址由用户设置，本站所有者不对其网站中的内容负责。"
  p2: "使用本站创建的短网址有失效的可能，本站无须对此做出解释，亦不会通知用户。"
  p3: "您使用本站的权利不受约束保护，本站所有者随时有权终止本站服务。"
  p4: "本站的网络可访问性不被保证。"
  p5: "您不会滥用本站服务，包括但不限于：进行巨量请求、非法爬取数据、尝试获取服务器管理员权限和利用本站服务传播违法不良信息或从事违法活动。"
</i18n>

<script>
    export default {
        data() {
            return {
                kotoriImg: require('./mikan.jpg'),
                selectCooldown: false,
            }
        },
    }
</script>

<style scoped>

    p >>> a {
        color: #c45a5b;
    }

    .kotori {
        min-width: 146px;
    }

    .wrapper {
        border-style: dotted;
        border-width: 0.3em;
        -webkit-border-radius: 1em;
        -moz-border-radius: 1em;
        border-radius: 1em;
        border-color: #c45a5b;

    }

    .btn-kawaii {
        background-color: #c45a5b;
    }

    .text-kotori {
        color: #efb48a;
        -webkit-transition: font-size 0.5s;
        -moz-transition: font-size 0.5s;
        -ms-transition: font-size 0.5s;
        -o-transition: font-size 0.5s;
        transition: font-size 0.5s;
    }

    @media screen and (min-width: 1200px) {
        .text-kotori {
            font-size: 5em;
        }
    }

    @media screen and (min-width: 992px) and (max-width: 1200px) {
        .text-kotori {
            font-size: 4em;
        }
    }

    @media screen and (min-width: 768px) and (max-width: 992px) {
        .text-kotori {
            font-size: 3em;
        }
    }

    @media screen and (min-width: 576px) and (max-width: 768px) {
        .text-kotori {
            font-size: 2em;
        }
    }

    @media screen and (max-width: 576px) {
        .text-kotori {
            font-size: 1.5em;
        }
        .form-pc {
            margin: 1rem 0.1rem;
        }
        .form-pc button {
            margin-top: 0.2rem;
        }
        .pb-3 {
            padding-bottom: 0!important;
        }
    }

    .url-input {
        /*margin: 0.3em 0.2em 0 0;*/
    }
</style>


// WEBPACK FOOTER //
// about.vue?1d3c5e4e